<template lang="pug">
.section
  .level.is-mobile
    .level-left.collapse-trigger(v-on:click="clickToggle")
      .level-item
        .image.is-72x72
          img(v-bind:src="partyAvatarUrl")
      .level-item
        .content
          strong {{ partyName }}
          div {{ distance }}
          div {{ price }}
    .level-right
      .level-item.collapse-trigger(v-on:click="clickToggle")
        .icon
          i.fas(v-bind:class="angleClass")
      .level-item
        .button.is-primary(v-on:click="clickBookNow") Book Now
  b-collapse(v-bind:open.sync="open")
    client-professional-profile(v-bind:locations="apiLocations", v-bind:professional="professional")
  br
</template>

<script>
import ClientProfessionalProfile from '@/components/ClientProfessionalProfile.vue'

import ApiMixin from '@/mixins/ApiMixin.vue'

export default {
  components: {
    ClientProfessionalProfile
  },
  mixins: [
    ApiMixin
  ],
  props: {
    professional: {
      required: true,
      type: Object
    },
    professionalOnlineLocation: {
      default: null,
      required: false,
      type: Number
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    angleClass () {
      return this.open ? 'fa-angle-up' : 'fa-angle-down'
    },
    distance () {
      return `${this.professional.locations[0].distanceFromOrigin.toFixed(2)} miles`
    },
    party () {
      return this.apiProfessionals.find((professional) => professional.id === this.professional.id)
    },
    partyAvatarUrl () {
      return this.party && this.party.avatar ? this.party.avatar.url : 'png/user.png'
    },
    partyName () {
      return this.isExternalprofessional ? 'External professional' : this.party ? this.party.name : null
    },
    price () {
      return `£${this.professional.prices[0].General.price1}/h`
    }
  },
  methods: {
    clickBookNow () {
      this.$root.$emit('bookNow', this.professionalOnlineLocation ? this.professionalOnlineLocation : this.professional.locations[0].id, this.professional.id)
    },
    clickToggle () {
      this.open = !this.open
    }
  }
}
</script>

<style lang="sass">
.collapse-trigger
  cursor: pointer
</style>
